import PropTypes from 'prop-types';
import React from 'react';

import { translate as t } from '../../lib/I18n';

function SectionErrors ({ errors }) {
    if (!errors.length) {
        return null;
    }
    return (
        <div tabIndex="0" className="alert alert-warning">
            <ul>
                { errors.map((error, key) => {
                    return (
                        <li key={ key }>
                            { t(error) }
                        </li>
                    );
                }) }
            </ul>
        </div>
    );
}

SectionErrors.propTypes = {
    errors: PropTypes.array
};

SectionErrors.defaultProps = {
    errors: []
};

export default SectionErrors;



// WEBPACK FOOTER //
// ./src/components/search/SectionErrors.js